import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminRallyResultsLayout from '../../../layout/AdminRallyResultsLayout';
import { getRallyResults, getRallyResultsFile } from '../../../api/admin/results';
import { setIsModalOpen, setModalContent, setModalContentProps, } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import Loader from '../../../ui/Loader';
import Headline from '../../../ui/Headline';
import { RALLY_SESSIONS_LIST_PER_PAGE_ITEMS } from '../../../app.config.vars/stored';
import Pagination from '../../../components/Pagination';
import AdminSessionsList from '../../../modules/AdminSessionsList';
import RallySessionsFilters from '../../../modules/AdminSessionsFilters';
import Button from '../../../ui/Button';
import DeleteIcon from '../../../assets/icons/delete.svg';
import { useSelector } from 'react-redux';
import { selectRallyResultsWasDeleted, setRallyResultsWasDeleted, } from '../../../store/adminSlices/rallies';
export const RallySessionsPage = () => {
    const { id } = useParams();
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const rallyResultsWasDeleted = useSelector(selectRallyResultsWasDeleted);
    const [resultsStatus, setResultsStatus] = useState(null);
    const [results, setResults] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const fetchRallyData = async () => {
        setResultsStatus('pending');
        try {
            const res = await getRallyResults({
                rallyId: id,
                params: { page: currentPage, startDate: startDate, endDate: endDate },
            });
            const results = await res.data;
            setResults(results);
            setTotalPages(Math.ceil(results.pagination.totalItems / RALLY_SESSIONS_LIST_PER_PAGE_ITEMS));
            setResultsStatus('success');
        }
        catch (err) {
            setResultsStatus('error');
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    useEffect(() => {
        setCurrentPage(1);
    }, [startDate, endDate]);
    useEffect(() => {
        fetchRallyData();
    }, [i18n.language, currentPage, startDate, endDate]);
    useEffect(() => {
        if (rallyResultsWasDeleted) {
            fetchRallyData();
            dispatch(setRallyResultsWasDeleted(false));
        }
    }, [rallyResultsWasDeleted]);
    const downloadCsvData = async () => {
        try {
            const res = await getRallyResultsFile(id);
            const jsonString = JSON.stringify(res.data, null, 2);
            const blob = new Blob([jsonString], { type: 'application/json' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const contentDisposition = res.headers['content-disposition'];
            const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
            a.download = filenameMatch ? filenameMatch[1] : 'data.csv';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }
        catch (err) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return results ? (_jsx(AdminRallyResultsLayout, { rallyId: id, rallyTitle: results.rally.title[i18n.language], themes: results.rally.themes, geographicArea: results.rally.geographicArea, targetGroups: results.rally.targetGroups, playerCount: results.playerCount, finishRate: results.finishRate, time: results.averageTime, view: "list", title: t('admin.rally_participants', { count: results.playerCount }), children: _jsxs(_Fragment, { children: [_jsxs("div", { className: "rally-sessions-navigation", children: [_jsx(RallySessionsFilters, { startDate: startDate, endDate: endDate, setStartDate: setStartDate, setEndDate: setEndDate }), _jsxs("div", { className: "rally-sessions-controls", children: [_jsx("a", { className: "link-button", onClick: downloadCsvData, tabIndex: 0, onKeyDown: async (event) => {
                                        if (event.code === 'Space' || event.code === 'Enter') {
                                            event.preventDefault();
                                            await downloadCsvData();
                                        }
                                    }, children: t('button.download_results') }), _jsx(Button, { onClick: () => {
                                        dispatch(setIsModalOpen(true));
                                        dispatch(setModalContent(MODAL_CONTENT.confirmDeleteRallyStatistic.key));
                                        dispatch(setModalContentProps({ rallyId: id, resultsAmount: results.playerCount }));
                                    }, label: t('button.delete_rally_statistic'), icon: _jsx(DeleteIcon, {}) })] })] }), resultsStatus === 'pending' ? (_jsx(Loader, {})) : (_jsxs("div", { className: "rally-sessions", children: [results.gameSessions.length ? (_jsx(AdminSessionsList, { rallyId: results.rally.uid, sessions: results.gameSessions })) : (_jsx(Headline, { title: t('admin.no_sessions_found'), type: 'h3' })), totalPages > 1 && (_jsx(Pagination, { currentPage: currentPage, totalPages: totalPages, onPageChange: setCurrentPage }))] }))] }) })) : (_jsx(Loader, {}));
};
export default RallySessionsPage;
